/**
 * Newsletter popup functionality for Pastiche theme
 */
document.addEventListener('DOMContentLoaded', function () {
  // Initialize the newsletter popup
  initNewsletterPopup();
  // Initialize AJAX form submission
  initNewsletterForm();
  // Initialize section position tracking
  initSectionPositionTracking();
  // Initialize shop menu
  initShopMenu();
  // Initialize cart interaction
  initCartInteraction();
  // Initialize custom product raw image modal
  initProductRawImageModal();
  // Initialize custom product slider navigation
  initProductSliderNavigation();
  // Initialize fit text for Alternate Hero layout
  // initFitText();
});

/**
 * Initialize cart interaction to close other menus when cart is opened
 */
function initCartInteraction() {
  document.addEventListener('cart:open', function () {
    // Close the shop menu if it's open
    closeShopMenu();
    // Close the newsletter popup if it's open
    closeNewsletterPopup();
  });
}

/**
 * Initialize section position tracking to add classes to body when sections are active
 */
function initSectionPositionTracking() {
  const sections = document.querySelectorAll('.section');
  if (!sections.length) return;

  // Add a data attribute to each section with its index
  sections.forEach((section, index) => {
    section.setAttribute('data-section-index', index + 1);
  });

  const subSections = document.querySelectorAll('.sub-section');

  // Add a data attribute to each sub-section with its index
  subSections.forEach((subSection, index) => {
    subSection.setAttribute('data-sub-section-index', index + 1);
  });

  // Function to update body classes based on section positions
  function updateSectionPositions() {
    const viewportHeight = window.innerHeight;
    const viewportMidpoint = viewportHeight / 2;
    const bodyClasses = document.body.classList;

    // Remove all existing section position classes
    const existingClasses = Array.from(bodyClasses).filter(
      (cls) => cls.includes('section_') && cls.includes('_active')
    );

    existingClasses.forEach((cls) => bodyClasses.remove(cls));

    // Find the most visible section to mark as active
    let mostVisibleSection = null;
    let largestVisibleArea = 0;

    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();

      // Calculate the visible area of the section within the viewport
      const visibleTop = Math.max(0, rect.top);
      const visibleBottom = Math.min(viewportHeight, rect.bottom);
      const visibleHeight = Math.max(0, visibleBottom - visibleTop);

      // The section with the largest visible area will be considered active
      if (visibleHeight > largestVisibleArea) {
        largestVisibleArea = visibleHeight;
        mostVisibleSection = section;
      }
    });

    // Mark the most visible section as active
    if (mostVisibleSection) {
      const sectionIndex = mostVisibleSection.getAttribute('data-section-index');
      bodyClasses.add(`section_${sectionIndex}_active`);
    }
  }

  // Function to update body classes based on sub-section positions
  function updateSubSectionPositions() {
    const viewportHeight = window.innerHeight;
    const viewportMidpoint = viewportHeight / 2;
    const bodyClasses = document.body.classList;

    // Remove all existing sub-section position classes
    const existingClasses = Array.from(bodyClasses).filter(
      (cls) => cls.includes('sub-section_') && cls.includes('_active')
    );

    existingClasses.forEach((cls) => bodyClasses.remove(cls));

    // Find the most visible sub-section to mark as active
    let mostVisibleSubSection = null;
    let largestVisibleArea = 0;

    subSections.forEach((subSection) => {
      const rect = subSection.getBoundingClientRect();

      // Calculate the visible area of the section within the viewport
      const visibleTop = Math.max(0, rect.top);
      const visibleBottom = Math.min(viewportHeight, rect.bottom);
      const visibleHeight = Math.max(0, visibleBottom - visibleTop);

      // The sub-section with the largest visible area will be considered active
      if (visibleHeight > largestVisibleArea) {
        largestVisibleArea = visibleHeight;
        mostVisibleSubSection = subSection;
      }
    });

    // Mark the most visible sub-section as active
    if (mostVisibleSubSection) {
      const subSectionIndex = mostVisibleSubSection.getAttribute('data-sub-section-index');
      bodyClasses.add(`sub-section_${subSectionIndex}_active`);
    }
  }

  // Add event listeners
  window.addEventListener('scroll', updateSectionPositions, { passive: true });
  window.addEventListener('resize', updateSectionPositions, { passive: true });
  window.addEventListener('scroll', updateSubSectionPositions, { passive: true });
  window.addEventListener('resize', updateSubSectionPositions, { passive: true });

  // Initial call to set correct classes
  updateSectionPositions();
  updateSubSectionPositions();
}

/**
 * Initialize shop menu dropdown functionality
 */
function initShopMenu() {
  const shopMenuToggle = document.getElementById('shop-menu-toggle');
  const menuPanel = document.getElementById('shop-menu-panel');

  if (!shopMenuToggle || !menuPanel) return;

  // Toggle shop menu panel when clicking the SHOP button
  shopMenuToggle.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const isActive = menuPanel.classList.contains('active');

    if (isActive) {
      closeShopMenu();
    } else {
      openShopMenu();
    }
  });

  // Close shop menu when clicking outside
  document.addEventListener('click', function (e) {
    if (menuPanel.classList.contains('active') && !menuPanel.contains(e.target) && e.target !== shopMenuToggle) {
      closeShopMenu();
    }
  });

  // Prevent clicks inside the menu from closing it
  menuPanel.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  // Close menu on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menuPanel.classList.contains('active')) {
      closeShopMenu();
    }
  });
}

/**
 * Open the shop menu panel
 */
function openShopMenu() {
  const menuPanel = document.getElementById('shop-menu-panel');
  const shopMenuToggle = document.getElementById('shop-menu-toggle');

  if (menuPanel) {
    // First make it visible with display block, then transition opacity
    // menuPanel.style.display = 'block';

    // Trigger reflow before adding the active class for the transition to work
    menuPanel.offsetHeight;

    menuPanel.classList.add('active');
  }

  if (shopMenuToggle) {
    shopMenuToggle.classList.add('active');
  }

  // Close newsletter if it's open
  closeNewsletterPopup();

  // Close cart notification if it's open
  document.dispatchEvent(new CustomEvent('cart:close'));
}

/**
 * Close the shop menu panel
 */
function closeShopMenu() {
  const menuPanel = document.getElementById('shop-menu-panel');
  const shopMenuToggle = document.getElementById('shop-menu-toggle');

  if (menuPanel) {
    menuPanel.classList.remove('active');

    // Wait for the transition to finish before setting display to none
    menuPanel.addEventListener(
      'transitionend',
      function hideMenu() {
        // menuPanel.style.display = 'none';
        menuPanel.removeEventListener('transitionend', hideMenu);
      },
      { once: true }
    );
  }

  if (shopMenuToggle) {
    shopMenuToggle.classList.remove('active');
  }
}

/**
 * Cookie utility functions for newsletter popup
 */
function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/**
 * Initialize newsletter popup functionality
 */
function initNewsletterPopup() {
  const newsletterToggle = document.getElementById('newsletter-toggle');
  const newsletterPopup = document.getElementById('newsletter-signup');
  const newsletterClose = document.getElementById('newsletter-close');

  if (!newsletterPopup) return;

  // Get settings from data attributes
  const autoShow = newsletterPopup.getAttribute('data-auto-show') === 'true';
  const cookieDays = parseInt(newsletterPopup.getAttribute('data-cookie-days') || '7', 10);
  const cookieName = 'pastiche_newsletter_closed';

  // Check if we should show the popup on page load
  if (autoShow && !getCookie(cookieName)) {
    // Wait a moment before showing the popup for better UX
    setTimeout(() => {
      openNewsletterPopup();
    }, 2000);
  }

  // Toggle newsletter popup when clicking the newsletter button
  if (newsletterToggle) {
    newsletterToggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isActive = newsletterPopup.classList.contains('active');

      if (isActive) {
        closeNewsletterPopup();
      } else {
        openNewsletterPopup();
      }
    });
  }

  // Close newsletter popup when clicking the close button
  if (newsletterClose) {
    newsletterClose.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Set a cookie to remember that the user closed the popup
      setCookie(cookieName, 'true', cookieDays);

      closeNewsletterPopup();
    });
  }

  // Close newsletter when clicking outside
  document.addEventListener('click', function (e) {
    if (
      newsletterPopup.classList.contains('active') &&
      !newsletterPopup.contains(e.target) &&
      e.target !== newsletterToggle
    ) {
      // Set a cookie to remember that the user closed the popup
      setCookie(cookieName, 'true', cookieDays);

      closeNewsletterPopup();
    }
  });

  // Prevent clicks inside the newsletter from closing it
  newsletterPopup.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  // Close newsletter on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && newsletterPopup.classList.contains('active')) {
      // Set a cookie to remember that the user closed the popup
      setCookie(cookieName, 'true', cookieDays);

      closeNewsletterPopup();
    }
  });

  // Show the close button when the popup is active
  newsletterPopup.addEventListener('transitionend', function () {
    if (newsletterPopup.classList.contains('active') && newsletterClose) {
      // newsletterClose.classList.remove('hidden');
    }
  });
}

/**
 * Initialize AJAX form submission for newsletter
 */
function initNewsletterForm() {
  // The newsletter form is now handled through Shopify's native form system
  // We only need to handle the toggle functionality, not the form submission

  // If there are success messages after page load, close the popup after a delay
  const successMessage = document.getElementById('HeaderContactFormSuccess');
  if (successMessage) {
    setTimeout(() => {
      closeNewsletterPopup();
    }, 3000);
  }
}

/**
 * Open the newsletter popup
 */
function openNewsletterPopup() {
  const newsletterPopup = document.getElementById('newsletter-signup');
  const newsletterClose = document.getElementById('newsletter-close');

  if (newsletterPopup) {
    newsletterPopup.classList.add('active');
    // Show close button immediately
    if (newsletterClose) {
      // newsletterClose.classList.remove('hidden');
    }
  }

  // Close shop menu if it's open
  closeShopMenu();

  // Close cart notification if it's open
  document.dispatchEvent(new CustomEvent('cart:close'));
}

/**
 * Close the newsletter popup
 */
function closeNewsletterPopup() {
  const newsletterPopup = document.getElementById('newsletter-signup');
  const newsletterClose = document.getElementById('newsletter-close');

  if (newsletterPopup) {
    newsletterPopup.classList.remove('active');
    // Hide close button
    if (newsletterClose) {
      newsletterClose.classList.add('hidden');
    }
  }
}

/**
 * Fit text functionality for Alternate Hero layout
 */
function initFitText() {
  // Find all .alternate-hero__wild-ones elements
  const elasticTextElements = document.querySelectorAll('.alternate-hero__wild-ones');

  if (elasticTextElements.length === 0) return;

  // Resize function
  const resizeText = () => {
    elasticTextElements.forEach((element) => {
      // Get parent container
      const container = element.closest('.alternate-hero__bottom');
      if (!container) return;

      // Get container width (accounting for padding)
      const containerWidth = container.clientWidth * 0.9; // 90% of container width to leave some margin

      // Start with a large font size
      let fontSize = 120;
      element.style.fontSize = `${fontSize}px`;

      // Reduce font size until it fits
      while (element.scrollWidth > containerWidth && fontSize > 20) {
        fontSize -= 1;
        element.style.fontSize = `${fontSize}px`;
      }
    });
  };

  // Initial resize
  resizeText();

  // Listen for window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    // Debounce resize event
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(resizeText, 100);
  });

  // Listen for orientation change
  window.addEventListener('orientationchange', resizeText);
}

/**
 * Initialize custom product image modal functionality for the raw product template
 * This bypasses Shopify's default modal trigger system with a direct approach
 */
function initProductRawImageModal() {
  // Check if we're on a product page with the raw template
  const productRaw = document.querySelector('.product-raw');
  if (!productRaw) return;

  // Find all product image links in the raw template
  const imageLinks = productRaw.querySelectorAll('.product-raw__media-link');
  if (!imageLinks.length) return;

  // Find the product modal component
  const productModal = document.querySelector('product-modal');
  if (!productModal) return;

  // Get the dialog element inside the modal
  const modalDialog = productModal.querySelector('[role="dialog"]');
  if (!modalDialog) return;

  // Add click event listener to all image links
  imageLinks.forEach((link) => {
    link.addEventListener('click', function (event) {
      // Prevent default link behavior
      event.preventDefault();

      // Get the media ID from the clicked link
      const mediaId = link.getAttribute('data-media-id');
      if (!mediaId) return;

      // Store the opening element on the modal (this is what the modal JS expects)
      productModal.openedBy = link;

      // If the modal has an open method, use it
      if (typeof productModal.show === 'function') {
        productModal.show(link);
      }
      // Otherwise try to open the dialog directly
      else if (modalDialog && typeof modalDialog.showModal === 'function') {
        modalDialog.showModal();

        // Manually set the active media
        const mediaItems = productModal.querySelectorAll('[data-media-id]');
        mediaItems.forEach((item) => {
          if (item.getAttribute('data-media-id') === mediaId) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });
      }
    });
  });

  // Also ensure the modal can be closed
  const closeButton = productModal.querySelector('[id^="ModalClose-"]');
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      if (typeof productModal.hide === 'function') {
        productModal.hide();
      } else if (modalDialog && typeof modalDialog.close === 'function') {
        modalDialog.close();
      }
    });
  }

  // Close on escape key
  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      productModal &&
      modalDialog &&
      (modalDialog.open || modalDialog.hasAttribute('open'))
    ) {
      if (typeof productModal.hide === 'function') {
        productModal.hide();
      } else if (modalDialog && typeof modalDialog.close === 'function') {
        modalDialog.close();
      }
    }
  });
}

/**
 * Initialize product slider navigation functionality
 * This adds custom handling for the product slider buttons
 */
function initProductSliderNavigation() {
  // Only run on product pages with media slider
  const mediaSliderWrapper = document.querySelector('.product-raw__media-slider-wrapper');
  if (!mediaSliderWrapper) return;

  const sliderList = mediaSliderWrapper.querySelector('.product-raw__media-slider-list');
  const slides = mediaSliderWrapper.querySelectorAll('.product-raw__media-slide');
  const prevButton = mediaSliderWrapper.querySelector('.slider-button--prev');
  const nextButton = mediaSliderWrapper.querySelector('.slider-button--next');
  const currentCounter = mediaSliderWrapper.querySelector('.slider-counter--current');

  if (!sliderList || !slides.length || !prevButton || !nextButton) return;

  // Set initial counter value
  let currentSlideIndex = 0;
  updateCounter();

  // Add click event listeners to navigation buttons
  prevButton.addEventListener('click', function () {
    navigateSlider('prev');
  });

  nextButton.addEventListener('click', function () {
    navigateSlider('next');
  });

  // Function to navigate the slider
  function navigateSlider(direction) {
    // Calculate new index
    if (direction === 'prev') {
      currentSlideIndex = currentSlideIndex > 0 ? currentSlideIndex - 1 : slides.length - 1;
    } else {
      currentSlideIndex = currentSlideIndex < slides.length - 1 ? currentSlideIndex + 1 : 0;
    }

    // Scroll to the new slide
    const targetSlide = slides[currentSlideIndex];
    if (targetSlide) {
      sliderList.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'smooth',
      });
    }

    // Update counter
    updateCounter();
  }

  // Function to update the slide counter
  function updateCounter() {
    if (currentCounter) {
      currentCounter.textContent = currentSlideIndex + 1;
    }
  }

  // Add scroll event listener to update counter when user scrolls manually
  sliderList.addEventListener(
    'scroll',
    debounce(function () {
      // Find which slide is most visible
      let maxVisibleWidth = 0;
      let maxVisibleIndex = 0;

      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const slideLeft = rect.left;
        const slideRight = rect.right;
        const sliderRect = sliderList.getBoundingClientRect();
        const sliderLeft = sliderRect.left;
        const sliderRight = sliderRect.right;

        // Calculate how much of the slide is visible
        const visibleLeft = Math.max(slideLeft, sliderLeft);
        const visibleRight = Math.min(slideRight, sliderRight);
        const visibleWidth = Math.max(0, visibleRight - visibleLeft);

        if (visibleWidth > maxVisibleWidth) {
          maxVisibleWidth = visibleWidth;
          maxVisibleIndex = index;
        }
      });

      if (currentSlideIndex !== maxVisibleIndex) {
        currentSlideIndex = maxVisibleIndex;
        updateCounter();
      }
    }, 100)
  );
}

/**
 * Simple debounce function for scroll events
 */
function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}
